import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Storage } from "@/uitls/Storage";
import {
  encryptionShowCustomer,
  encryptionScoreHome,
  encryptionGiftList,
  encryptionUserBuyGift,
} from "@/api/php/user";
import ICON_SPORTS from "@/assets/images/sports-medal.png";
import ICON_DETAIL from "@/assets/images/mingxi.png";
import ICON_RULE from "@/assets/images/guize.png";
import ICON_HOT from "@/assets/images/shop_remen.png";
import ICON_CLOSE from "@/assets/images/guanbi.png";
import ICON_BG from "@/assets/images/party-popper.png";
import { Toast } from "vant";
import { formatDate, YMPush } from "@/uitls/uitls";
import { cheackQuery, nativeToNewWeb, ToBack } from "@/uitls/native";
import { usePiniaState } from "@/store/userPinia";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  name: 'Integralwallet',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n();
const piniaStore = usePiniaState();
const { isQD } = storeToRefs(piniaStore);
const jfstore_icon_2 = require(`@/assets/${process.env.VUE_APP_NAME}/jfstore_icon_2.png`)
const jfstore_icon_5 = require(`@/assets/${process.env.VUE_APP_NAME}/jfstore_icon_5.png`)
const router = useRouter();
const route = useRoute();
const showVipAlertView = ref(false);
const black_close = require("@/assets/images/close_black.png");
//积分
let signin = ref();
let goodsList = ref([]);
let exchangeshow = ref(false);
let exchangedata = ref();
let showSign = ref(false);
let today_score = ref(0);

// const { uid, token, nav } = route.query;
//签到的日期
const dayList = ref([])
onMounted(() => {

  cheackQuery(route);
  getdata();
  YMPush('MAIN', 'ShopMall');
});

const getdata = () => {
  // getuser();
  getqiandao();
  getsing();
};

const today_data = ref()

const getqiandao = async () => {
  // 签到数据
  const res: any = await encryptionScoreHome();
  if (res.code == 200) {
    const time = new Date().getTime()
    //今天的日期
    const day = formatDate(time)
    Storage.set("jfStoreDay", day);
    isQD.value = true;
    console.log(res);
    signin.value = res.data
    dayList.value = res.data.day_list;
    if (res.data.sign_in_status == 0) {
      showSign.value = true;

      today_data.value = res.data.today_data

    }
  } else {
    Toast.fail(res.msg)
  }
};
const getsing = async () => {
  // 获取礼包数据
  const res: any = await encryptionGiftList({
    client_channel: 4,
    limit: 0,
    type: 50,
    page: 1,
  });
  if (res.code == 200) {
    
    goodsList.value = res.data.list;
  }
};


const exchange = (data) => {
  // 打开礼品兑换
  exchangeshow.value = true;
  exchangedata.value = data;
};
const exchangeclick = async (data) => {
  // 兑换点击
  console.log(data, "----");
  const res: any = await encryptionUserBuyGift({
    client_channel: 4,
    gift_id: data.id,
    num: 1,
  });
  if (res.code == 200) {
    router.push(
      `/IntegralExchange?score=${res.data.score}&&total_score=${res.data.total_score}`
    );
  } else {
    Toast.fail(res.msg);
  }
};

//vip折扣介绍
const vipClick = () =>{
    showVipAlertView.value = true;
}

const getVipText = (item,index) =>{
    if(item == 1){
        return `VIP${index}：${t('无折扣')}`
    }else{
        return `VIP${index}：${t('支付')} ${item*100}%`
    }
};

const jumpToVipDetailInfo = () =>{
    router.push('/viplevel')
};


const __returned__ = { t, piniaStore, isQD, jfstore_icon_2, jfstore_icon_5, router, route, showVipAlertView, black_close, signin, goodsList, exchangeshow, exchangedata, showSign, today_score, dayList, getdata, today_data, getqiandao, getsing, exchange, exchangeclick, vipClick, getVipText, jumpToVipDetailInfo, ICON_SPORTS, ICON_HOT, ICON_CLOSE, ICON_BG, nativeToNewWeb, ToBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})